export default "__VITE_ASSET__0e027d8f__"